// 재사용 확인 레이어 팝업
interface Props {
  title: string;
  message: string;
  confirmLabel?: string;
  danger?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({
  title,
  message,
  confirmLabel = '확인',
  danger,
  onConfirm,
  onCancel,
}: Props) {
  return (
    <div class="modal-backdrop" onClick={onCancel}>
      <div class="modal" style="max-width:400px" onClick={(e) => e.stopPropagation()}>
        <h2 class="modal__title">{title}</h2>
        <p style="color:var(--c-text);font-size:14px;line-height:1.6;margin:0 0 20px">{message}</p>
        <div class="row row--end">
          <button class="btn" onClick={onCancel}>
            취소
          </button>
          <button
            class={`btn ${danger ? 'btn--danger' : 'btn--primary'}`}
            onClick={onConfirm}
            autoFocus
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
